<script>
import Layout from '@layouts/main.vue'
import OverdueInvoicesByClientList from '@/components/finance/overdue-invoices-by-client-list.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Overdue Invoices page.' }],
    }
  },
  components: { Layout, OverdueInvoicesByClientList },
}
</script>

<template>
  <Layout>
    <v-container fluid>
      <OverdueInvoicesByClientList />
    </v-container>
  </Layout>
</template>
